import { render, staticRenderFns } from "./Jump.vue?vue&type=template&id=2286af9e&scoped=true&"
import script from "./Jump.vue?vue&type=script&lang=js&"
export * from "./Jump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286af9e",
  null
  
)

export default component.exports